// extracted by mini-css-extract-plugin
export var boldText = "_8c-4";
export var checkboxContainer = "_8c-6";
export var closeIcon = "_8c-i";
export var container = "_8c-0";
export var drawer = "_8c-8";
export var drawerContent = "_8c-9";
export var extraSmallText = "_8c-5";
export var fulfillmentGroupTable = "_8c-e";
export var largeText = "_8c-3";
export var loadingSpinnerContainer = "_8c-j";
export var mediumText = "_8c-2";
export var narrow = "_8c-f";
export var notificationLink = "_8c-l";
export var packageCheckIconContainer = "_8c-7";
export var slideoutHeaderActions = "_8c-g";
export var slideoutHeaderActionsShifted = "_8c-h";
export var slideoutHeaderContainer = "_8c-a";
export var slideoutModal = "_8c-c";
export var stickyHeaderWrapper = "_8c-b";
export var table = "_8c-k";
export var tableContainer = "_8c-d";
export var tertiaryText = "_8c-1";